import { AppRoutes } from "../../constants";
import { useAppDispatch } from "../../redux";
import { setIsPaneemTypeSelected } from "../../AppSlice";
import { overrideAttempts } from "../ImageCapture/ImageCaptureSlice";
import { useNavigate, useParams } from "react-router-dom";

export default function Override() {
  const dispatch = useAppDispatch();
  const { number } = useParams();

  const navigate = useNavigate();

  if (number && !isNaN(Number(number))) dispatch(overrideAttempts(Number(number)));
  else dispatch(overrideAttempts(2));

  dispatch(setIsPaneemTypeSelected());

  navigate(AppRoutes.home);

  return null;
}
